export enum FetchState {
  NONE = 'none',
  FETCHING = 'fetching',
  SUCCESS = 'success',
  ERROR = 'error',
}